import {
  BOARD_TYPE_ALL_INCLUSIVE,
  BOARD_TYPE_DAILY_BREAKFAST,
  BOARD_TYPE_DAILY_BREAKFAST_AND_LUNCH_AND_DINNER,
  BOARD_TYPE_DAILY_BREAKFAST_AND_LUNCH_OR_DINNER,
} from '~/consts/ratePlans';

const includesKeyword = (texts: Array<string>, keyword: string): boolean =>
  texts.some((text) => text.toLowerCase().includes(keyword));

export function getMissingMealKeywords(boardType: string, texts: Array<string>): Array<string> {
  const hasBreakfast = includesKeyword(texts, 'breakfast');
  const hasLunch = includesKeyword(texts, 'lunch');
  const hasDinner = includesKeyword(texts, 'dinner');

  switch (boardType) {
    case BOARD_TYPE_DAILY_BREAKFAST:
      return hasBreakfast ? [] : ['breakfast'];

    case BOARD_TYPE_DAILY_BREAKFAST_AND_LUNCH_OR_DINNER: {
      const missing: Array<string> = [];
      if (!hasBreakfast) {
        missing.push('breakfast');
      }
      if (!hasLunch && !hasDinner) {
        missing.push('lunch or dinner');
      }
      return missing;
    }

    case BOARD_TYPE_DAILY_BREAKFAST_AND_LUNCH_AND_DINNER:
    case BOARD_TYPE_ALL_INCLUSIVE: {
      const missing: Array<string> = [];
      if (!hasBreakfast) {
        missing.push('breakfast');
      }
      if (!hasLunch) {
        missing.push('lunch');
      }
      if (!hasDinner) {
        missing.push('dinner');
      }
      return missing;
    }

    default:
      return [];
  }
}
